/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { Effect, WorkOrderTask } from "../../utils/Interfaces";
import { CardContent, IconButton, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { AddCircle } from "@mui/icons-material";
import { useCreateWorkOrderTask } from "./workOrderHooks";
import WorkOrderTaskEditor from "./WorkOrderTaskEditor";

export interface WorkOrderTasksProps {
    workOrderId: number;
    tasks: WorkOrderTask[];
    allowTaskEdit: boolean;

    // TODO These are hacks that are used to connect React Query with the old querying implementation on the technician dashboard.
    additionalAction?: Effect;
}

const WorkOrderTasks = (props: WorkOrderTasksProps) => {
    const { workOrderId, tasks, allowTaskEdit, additionalAction } = props;

    const [label, setLabel] = useState<string>("");

    const { mutate: createWorkOrderTask } = useCreateWorkOrderTask(workOrderId);

    function handleCreateWorkOrderTask() {
        createWorkOrderTask({ label: label, details: "" });
        setLabel("");
    }

    return (
        <CardContent>
            {tasks.length === 0 && (
                <Typography variant="subtitle2" textAlign="center" sx={{ mb: 4 }} color="text.secondary">
                    Work order does not have any defined tasks.
                </Typography>
            )}

            {tasks.map((task: WorkOrderTask, index: number) => {
                return (
                    <WorkOrderTaskEditor
                        workOrderId={workOrderId}
                        task={task}
                        allowTaskEdit={allowTaskEdit}
                        additionalAction={additionalAction}
                        key={index}
                    />
                );
            })}

            <Stack direction="row" justifyContent="space-between" sx={{ mt: 3 }}>
                <TextField
                    placeholder="Add a new punchlist item to this work order"
                    size="small"
                    fullWidth
                    variant="outlined"
                    value={label}
                    onChange={(event) => setLabel(event.target.value)}
                    InputProps={{
                        style: {
                            borderRadius: 10,
                        },
                        endAdornment: (
                            <InputAdornment position="end" sx={{ mr: -1 }}>
                                <IconButton
                                    onClick={() => handleCreateWorkOrderTask()}
                                    disabled={label.trim() === ""}
                                    color="primary"
                                >
                                    <AddCircle />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Stack>
        </CardContent>
    );
};

export default WorkOrderTasks;
